<div
  class="mui-carousel_slide-container"
  #slider
  [class.dragging]="dragging"
  [style.transform]="_getTranslatePos()"
  [style.height]="_containerHeight() !== null ? _containerHeight() + 'px' : null">
  <div
    *ngFor="let slide of slides; let i = index"
    #slideContainer
    role="tabpanel"
    class="mui-carousel_slide"
    [attr.id]="getSlideId(i)"
    [attr.aria-labelledby]="getIndicatorId(i)"
    [attr.aria-hidden]="i !== currentIndex"
    [style.left]="i * 100 + '%'"
    [style.opacity]="i === currentIndex ? 1 : 0"
    [class.current]="i === currentIndex">
    <ng-container [ngTemplateOutlet]="slide.content"></ng-container>
  </div>
</div>
<nav class="mui-carousel_navigation">
  <button
    mui-icon-btn
    appearance="ghost"
    icon="angle-left"
    type="button"
    class="mui-carousel_navigation_previous"
    (click)="previous()"
    [label]="(translations$ | async)?.previousButton"
    [disabled]="currentIndex === 0"></button>
  <button
    mui-icon-btn
    appearance="ghost"
    icon="angle-right"
    type="button"
    class="mui-carousel_navigation_next"
    (click)="next()"
    [label]="(translations$ | async)?.nextButton"
    [disabled]="currentIndex === slides.toArray().length - 1"></button>
</nav>
<ul class="mui-carousel_slide-indicators">
  <li
    *ngFor="let slide of slides; let i = index"
    class="mui-carousel_slide-indicators_indicator"
    role="tab"
    [attr.id]="getIndicatorId(i)"
    [attr.aria-label]="slide.label"
    [attr.aria-controls]="getSlideId(i)"
    [attr.aria-selected]="i === currentIndex"
    (click)="goToSlide(i)"
    [class.current]="i === currentIndex"></li>
</ul>
